import React from 'react';
import PageContainer from '@deliveroo/consumer-component-library/components/PageContainer';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import i18n from '../../utils/i18n';
import styles from './HowDeliverooWorks.scss';

export default function HowDeliverooWorks() {
  return (
    <div className={styles.howitworks}>
      <PageContainer>
        <Heading color="black" level={2} size="medium">
          {i18n.gettext('landingPage.cuisine.howitworks.heading')}
        </Heading>

        <Spacer adjacentVerticalSpacing={{ mobile: 'small', desktop: 'x-large' }}>
          <ol className={styles.steps}>
            <li className={styles.order}>
              <Spacer spacing={{ mobile: 'large', desktop: 'x-large' }}>
                <Heading color="white" level={3} size="medium">
                  {i18n.gettext('landingPage.cuisine.howitworks.steps.order')}
                </Heading>
                <div className={styles.image} />
              </Spacer>
            </li>
            <li className={styles.track}>
              <Spacer spacing={{ mobile: 'large', desktop: 'x-large' }}>
                <Heading color="white" level={3} size="medium">
                  {i18n.gettext('landingPage.cuisine.howitworks.steps.track')}
                </Heading>
                <div className={styles.image} />
              </Spacer>
            </li>
            <li className={styles.eat}>
              <Spacer spacing={{ mobile: 'large', desktop: 'x-large' }}>
                <Heading color="white" level={3} size="medium">
                  {i18n.gettext('landingPage.cuisine.howitworks.steps.eat')}
                </Heading>
                <div className={styles.image} />
              </Spacer>
            </li>
          </ol>
        </Spacer>
      </PageContainer>
    </div>
  );
}
